module.exports = {
	api: `${process.env.REACT_APP_BAMBOO_API || 'https://vpp-api.carbonzero.com.hk/v1/'}`,
	version: `${process.env.REACT_APP_VERSION || '1.00.00'}`
};
